import { useMemo } from 'react';
import { CompanyContactType } from '@api';
import {
  getContactPersonOptions,
  getContactSelectFieldValue,
  mapContactSelectChange,
} from '../../helpers';
import { CompanyContactSelectValueType } from '../../types';

type UseCompanyContactSelectReturnType = {
  contactPersonOptions: ReturnType<typeof getContactPersonOptions>;
  handleChange: (
    value: string | null,
    onChange: (value: CompanyContactSelectValueType | null) => void
  ) => void;
  getFieldValue: (value: CompanyContactSelectValueType | null) => string | null;
};

export const useCompanyContactSelect = (
  data: CompanyContactType[]
): UseCompanyContactSelectReturnType => {
  const contactPersonOptions = useMemo(
    () => getContactPersonOptions(data),
    [data]
  );

  const handleChange = (
    value: string | null,
    onChange: (value: CompanyContactSelectValueType | null) => void
  ) => mapContactSelectChange(value, data, onChange);

  const getFieldValue = (value: CompanyContactSelectValueType | null) =>
    getContactSelectFieldValue(value, data);

  return { contactPersonOptions, handleChange, getFieldValue };
};
